import Navbar from "../components/navbar"
import Footer from "../components/footer"
import front_model from '../images/front-model.jpg'
import LoadingOverlay from "../components/loading"
import emptyList from "../components/empty_list"
import { useEffect, useState } from "react"
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCart } from "../hooks/add_to_cart"
import { FaTimes } from "react-icons/fa";
import {LiaTimesSolid} from "react-icons/lia";
import { ProductDetails } from "../components/product_details"
import { useCookies } from "react-cookie"
import { useNavigate, useParams } from "react-router-dom"
import { BarLoader } from "react-spinners"
import { PayPalButtons } from "@paypal/react-paypal-js";
import { IoMdCheckmarkCircleOutline } from "react-icons/io"

export default function RefundPolicy({ route }) {
    const [pageLoading, setPageLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [featured_prod, setFeaturedProd] = useState([]);
    const [products, setProducts] = useState([]);
    const { addToCart, checkItemInCart, removeItem, convertAmount } = useCart();
    const [showModal, setShowModal] = useState(false);
    const [showDetails, setShowDetails] = useState({});
    const [cookies, removeCookie] = useCookies();
    const navigate = useNavigate();
    const [payment, setPayment] = useState("cod");
    const [pageData, setPageData] = useState({});
    const {reference} = useParams();

    return(
        <div className="w-full h-auto">
            {pageLoading && <LoadingOverlay />}
            <Navbar />
            <div className="max-w-6xl mx-auto px-4 py-6">
                <div className="flex">
                    <button onClick={() => navigate(-1)} className="py-2 px-5 border rounded-sm my-2">Return to Shop</button>
                </div>
                <div className="max-w-5xl mx-auto px-4 py-10">
                    <h1 className="text-3xl font-semibold mb-6">
                        Refund & Exchange Policy
                    </h1>

                    <p className="text-gray-700 mb-6">
                        At <strong>Intimates By Itee Ltd</strong>, customer satisfaction is very
                        important to us. This Refund & Exchange Policy explains the conditions
                        under which refunds or exchanges may be requested. By placing an order
                        with us, you agree to the terms outlined below.
                    </p>

                    <section className="space-y-6 text-[#232323]">
                        <div>
                        <h2 className="text-xl font-semibold mb-2">
                            Eligibility for Refunds & Exchanges
                        </h2>
                        <p>
                            Due to the nature of our products, refunds or exchanges are only
                            accepted if the item is returned in its original condition. To be
                            eligible, the product must be:
                        </p>
                        <ul className="list-disc list-inside mt-2">
                            <li>Unused, unworn, and unaltered</li>
                            <li>In its original packaging</li>
                            <li>With all tags, seals, and accessories intact</li>
                        </ul>
                        </div>

                        <div>
                        <h2 className="text-xl font-semibold mb-2">
                            Non-Returnable Items
                        </h2>
                        <p>
                            For hygiene and safety reasons, we do not accept returns or
                            exchanges for:
                        </p>
                        <ul className="list-disc list-inside mt-2">
                            <li>Products that have been worn, installed, or altered</li>
                            <li>Products with broken seals or missing original packaging</li>
                            <li>Customised or made-to-order items</li>
                            <li>Sale or clearance items (unless faulty)</li>
                        </ul>
                        </div>

                        <div>
                        <h2 className="text-xl font-semibold mb-2">
                            Exchange Requests
                        </h2>
                        <p>
                            If you wish to exchange an item, please contact us within
                            <strong> 7 days</strong> of receiving your order. Exchanges are
                            subject to product availability. Customers are responsible for
                            return shipping costs unless the item received was incorrect or
                            faulty.
                        </p>
                        </div>

                        <div>
                        <h2 className="text-xl font-semibold mb-2">
                            Refund Process
                        </h2>
                        <p>
                            Once your returned item has been received and inspected, we will
                            notify you of the approval or rejection of your refund. If
                            approved, refunds will be processed to the original payment
                            method within <strong>5–10 business days</strong>.
                        </p>
                        </div>

                        <div>
                        <h2 className="text-xl font-semibold mb-2">
                            Shipping Costs
                        </h2>
                        <p>
                            Original shipping charges are non-refundable. Return shipping
                            costs are the responsibility of the customer unless the return is
                            due to an error on our part (wrong or defective item).
                        </p>
                        </div>

                        <div>
                        <h2 className="text-xl font-semibold mb-2">
                            Damaged or Incorrect Items
                        </h2>
                        <p>
                            If you receive a damaged or incorrect item, please contact us
                            within <strong>48 hours</strong> of delivery with clear photos of
                            the product and packaging. We will assess the issue and arrange a
                            replacement or refund where applicable.
                        </p>
                        </div>

                        <div>
                        <h2 className="text-xl font-semibold mb-2">
                            Cancellations
                        </h2>
                        <p>
                            Orders can only be cancelled before they have been processed or
                            shipped. Once an order has been shipped, cancellation is no longer
                            possible and our return policy will apply.
                        </p>
                        </div>

                        <div>
                        <h2 className="text-xl font-semibold mb-2">
                            Contact Us
                        </h2>
                        <p>
                            If you have any questions regarding our Refund & Exchange Policy,
                            please contact our customer support team. We are always happy to
                            assist you.
                        </p>
                        </div>
                    </section>
                </div>

            </div>
            <Footer />
        </div>
    )
}
